<template>
	<div :class="[
		'c-contact-entity',
		{'space--bottom': space}
	]">
		<template v-if="image">
			<div class="c-contact-entity__image">
				<img :src="image" height="45" width="45" alt="" aria-hidden="true" />
			</div>
		</template>
		<div class="c-contact-entity__content">
			<p class="c-contact-entity__heading">{{name}}</p>
			<p class="c-contact-entity__subheading">{{worktitle}}</p>
			<template v-if="text">
				<div class="c-contact-entity__text">
					{{text}}
				</div>
			</template>
			<template v-if="address">
				<p class="c-contact-entity__address">{{address}}</p>
			</template>
			<template v-if="phone">
				<p class="c-contact-entity__link">
					<a class="c-contact-entity__link-a" :href="'tel:' + phone">{{phone}}</a>
				</p>
			</template>
			<template v-if="email">
				<p class="c-contact-entity__link">
					<a class="c-contact-entity__link-a" :href="'mailto:' + email">{{email}}</a>
				</p>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VContactEntity',
	props: {
		image: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		worktitle: {
			type: String,
			default: ''
		},
		body: {
			type: String,
			default: ''
		},
		address: {
			type: String,
			default: ''
		},
		phone: {
			type: String,
			default: ''
		},
		email: {
			type: String,
			default: ''
		},
		space: {
			type: Boolean,
			default: false
		}
	}
}
</script>
